import React, { Component } from "react"
import styled, { keyframes } from "styled-components"
import { motion } from "framer-motion"

const BlackBar = styled.div`
	-moz-box-shadow:    inset 0 0 2vw #000000;
	-webkit-box-shadow: inset 0 0 2vw #000000;
	box-shadow:         inset 0 0 2vw #000000;
	background: rgb(34,34,34);
	background: linear-gradient(0deg, rgba(34,34,34,1) 0%, rgba(49,49,49,1) 33%,rgba(49,49,49,1) 50%, rgba(8,8,8,1) 80%);
	border-radius: ${p => p.rightCurveOnly ? '0 2vw 2vw 0' : '2vw'};

	width: 100%;
	height: 100%;
	border: 0.1vw solid black;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
`
const YellowBar = styled.div`
	-moz-box-shadow:    inset 0 0 2vw rgba(0,0,0,0.7);
	-webkit-box-shadow: inset 0 0 2vw rgba(0,0,0,0.7);
	box-shadow:         inset 0 0 2vw rgba(0,0,0,0.7);
	/* background-image: url('/assets/achievements') */
	background-color: rgba(0,0,0,0.2);
	border-radius: ${p => p.rightCurveOnly ? '0 2vw 2vw 0' : '2vw'};

	width: 100%;
	height: 100%;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
`

const liquidAnimation = keyframes`
	0% {
		background-position-x: 0vw;
	}
	100% {
		background-position-x: 100vw;
	}
`

const AnimatedBar = styled(motion.div)`
	background-color: rgb(149,52,227);
	background-image: linear-gradient(90deg, rgba(149,52,227,1) 0%, rgba(201,67,234,1) 50%, rgba(149,52,227,1) 100%);
	background-size: 100vw;
	height: 100%;
	width: 0;
	border-top: 0.25vw solid rgba(201,67,234,1);
	border-bottom: 0.25vw solid rgba(149,52,227,1);
	box-sizing: border-box;
	border-radius: ${p => p.rightCurveOnly ? '0 1vw 1vw 0' : '1vw'};
	animation-name: ${liquidAnimation};
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
`

// const InnerBar = styled(motion.div)`
// 	/* background: rgb(171,34,204);
// 	background: linear-gradient(0deg, rgba(171,34,204,1) 45%, rgba(214,118,239,1) 50%); */
// 	background: rgb(236,216,252);
// 	background: linear-gradient(180deg, rgba(236,216,252,1) 0%, rgba(186,118,242,1) 2%, rgba(115,39,199,1) 98%, rgba(206,67,236,1) 100%);
// 	height: 100%;
// 	width: 0;
// 	border-top: 0.25vw solid rgba(236,216,252,1);
// 	border-bottom: 0.25vw solid rgba(206,67,236,1);
// 	box-sizing: border-box;
// 	/* box-shadow: 0 0 20px rgba(236,216,252,1); */
// 	border-radius: ${p => p.rightCurveOnly ? '0 1vw 1vw 0' : '1vw'};
// `

const ProgText = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	text-align: center;
	color: white;
	letter-spacing: 0;
	font-size: 4vw;
	display: flex;
	justify-content: center;
	align-items: center;
	text-shadow: 0.3vw 0.3vw 0.3vw #120410, -0.3vw -0.3vw 0.3vw #120410, 0.3vw -0.3vw 0.3vw #120410, -0.3vw 0.3vw 0.3vw #120410;
`


export class ProgressBar extends Component {
	render(){
		const Bar = this.props.yellow ? YellowBar : BlackBar;
		return (
			<Bar rightCurveOnly={this.props.rightCurveOnly}>
				<AnimatedBar
					initial={this.props.initial}
					animate={this.props.animate || {width: this.props.percent+'%', transition: {delay: 0, duration: 0.5}}}
					transition={this.props.transition}
					rightCurveOnly={this.props.rightCurveOnly}
					onAnimationComplete={this.props.onAnimationComplete}
				/>
				<ProgText>{this.props.children}</ProgText>
			</Bar>
		);
	}
}